import React from 'react';
import TablaDTE from 'App/components/TablaDTE';
import Cesion from 'App/components/Cesion';
function Emitidos() {

    return (
        <div>
        <TablaDTE tipoDTE="emitidos" titulo="Emitidos" />
        <Cesion />
        </div>
    )
}

export default Emitidos;